import { Comment } from '../../interfaces/comment'
import useComment from '../../customHooks/useComment'
import EditCommentComponent from '../editCommentComponent/editCommentComponent'
import TextCommentComponent from '../textCommentComponent/textCommentComponent'
import ReplayFormComponent from '../replyFormComponent/replayFormComponent'
interface ICommentComponent extends Comment{
  replies:Array<Comment>
}
const CommentComponent = ({id,commentInfo,email,parentId,replies}:ICommentComponent) => {
  const {displayEdit,setDisplayEdit,displayNewReply,setDisplayNewReply} = useComment();
  const addPaddingLeft = ()=>{
    if(parentId){
      return{
        paddingLeft: "40px"
      }
    }
    return {}
  }
  const componentToDisplay = ()=>{
    if(displayEdit){
      return <EditCommentComponent commentInfo={commentInfo} email={email} id={id} setdisplayEdit={setDisplayEdit}   />
    }
      return <TextCommentComponent commentInfo={commentInfo} email={email} id={id} parentId={parentId} setdisplayEdit={setDisplayEdit} setDisplayNewReply={setDisplayNewReply} replies={replies} />

   }
  const ReplayToDisplay = ()=>{
    if(displayNewReply){
      return <ReplayFormComponent parentId={id} setDisplayNewReply={setDisplayNewReply}  />
    }  
   }
  const showReplies =()=>{
    let repliesToShow:any;
    if(replies.length>0){
      repliesToShow = replies.map((reply)=>{
          return <CommentComponent 
          key={reply.id}
          commentInfo={reply.commentInfo}
          email={reply.email}
          createdAt={reply.createdAt}
          id={reply.id}
          parentId={reply.parentId}
          replies={[]}

          />
          
      });
    }
    return repliesToShow;
  } 
  return (
    <div style={addPaddingLeft()} className="commentsContainer">
      {
        componentToDisplay()
      }
      {
        ReplayToDisplay()
      }
      {
        showReplies()
      }
    </div>
  )

}

export default CommentComponent